import { cnpj, cpf } from 'cpf-cnpj-validator';

export const isValidHolderIdentity = (identity: string | undefined, isForeign: boolean): boolean => {
  if (isForeign) {
    return true;
  }

  return cpf.isValid(identity ?? '') || cnpj.isValid(identity ?? '');
};
